<div class="yf-row center gap-6">
  <ion-icon src="assets/app-icons/parcheggio.svg" color="light" class="medium-icon"></ion-icon>
  <ion-text color="light" [class]="$textClass()">
    {{$parkingQuickText()}}
  </ion-text>
</div>